import { BASE_URL } from "@constants/api.constants";
import { uploadImageFile } from "@utils/upload.util";
import { autoCompleteAPI } from "../products-list/product-list.component.service";

export const getProductInputs = (initialValues) => [
  // console.log({initialValues}),
  {
    type: "TEXT",
    label: "Name",
    id: "name",
    name: "name",
    value: initialValues?.name || "",
    placeholder: "Enter the Name",
    validations: [
      {
        type: "REQUIRED",
        message: "Name is required !",
      },
    ],
  },
  {
    type: "FILE_UPLOAD",
    label: "Image",
    id: "image",
    name: "image",
    value: initialValues?.image || "",
    placeholder: "Upload the image",
    filePrefix: BASE_URL + "app-source/images/",
    handleSelfUpload: uploadImageFile,
    validations: [
      {
        type: "REQUIRED",
        message: "Image is required !",
      },
    ],
  },
  {
    type: "TEXT",
    label: "Slug",
    id: "slug",
    name: "slug",
    value: initialValues?.slug || "",
    placeholder: "Enter the slug",
  },
  {
    type: "SELECT",
    label: "Status",
    id: "status",
    name: "status",
    options: [
      { name: "Enabled", value: "1" },
      { name: "Disabled", value: "0" },
    ],
    value: initialValues?.status || "1",
    placeholder: "Select status",
  },
  {
    groupName: "Product Details",
    // groupClass: "col-md-12",
    type: "FORM_REPEATER",
    validations: [],
    name: "repeater",
    value: initialValues?.repeater || null,
    inputs: [
      {
        type: "TEXT",
        label: "Sort Order",
        id: "sort_order",
        name: "sort_order",
        placeholder: "Enter the Sort Order",
        size: 2,
      },
      {
        type: "TEXT_AUTOCOMPLETE",
        label: "Part Number",
        id: "inventory_id",
        name: "inventory_id",
        placeholder: "Enter the Part Number",
        size: 4,
        fetchOptions: autoCompleteAPI,
        formatOption: (option) => `${option.part_number}`,
      },
    ],
  },
];
